var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 5.33331H13.3334M2.66675 5.33331V11.2001C2.66675 11.9468 2.66675 12.32 2.81207 12.6052C2.9399 12.8561 3.14373 13.0603 3.39461 13.1881C3.67955 13.3333 4.05274 13.3333 4.79802 13.3333H11.2021C11.9474 13.3333 12.3201 13.3333 12.605 13.1881C12.8559 13.0603 13.0604 12.8561 13.1882 12.6052C13.3334 12.3203 13.3334 11.9476 13.3334 11.2024V5.33331M2.66675 5.33331V4.80011C2.66675 4.05337 2.66675 3.67973 2.81207 3.39451C2.9399 3.14363 3.14373 2.9398 3.39461 2.81197C3.67983 2.66665 4.05347 2.66665 4.80021 2.66665H5.33341M13.3334 5.33331V4.79792C13.3334 4.05264 13.3334 3.67945 13.1882 3.39451C13.0604 3.14363 12.8559 2.9398 12.605 2.81197C12.3198 2.66665 11.9469 2.66665 11.2002 2.66665H10.6667M5.33341 2.66665H10.6667M5.33341 2.66665V1.33331M10.6667 2.66665V1.33331M10.6667 7.99998H5.33341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.e001937fdf92c3395903e703b1ee234b.svg";
export { ForwardRef as ReactComponent };